class DateFormatter {
    public toLocaleString(date: Date, options?: Intl.DateTimeFormatOptions): string {
        return date.toLocaleString(undefined, options);
    }
}

export default new DateFormatter();
